.vs-content-card__2up-container {
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
  padding-bottom: 80px;

  @media (max-width: 480px) {
    padding-bottom: 48px;
  }
}

.vs-content-card__2up-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
}

.vs-content-card__2up-first-card {
  width: 50%;

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 2rem;
  }

  .vsr-card {
    max-width: 648px;
    @media (max-width: 768px) {
      max-width: none;
    }
  }

  vsr-product-card .vsr-product-card {
    max-width: 648px;
    max-height: 648px;
    @media (max-width: 768px) {
      max-width: none;
    }
  }

  vsr-product-card .vsr-product-card__fixed-image {
    width: 100%;
    max-width: 648px;
    height: auto;
    max-height: 648px;
    padding: 60px; /* Generous padding for consistent spacing */
    box-sizing: border-box;
    @media (max-width: 768px) {
      width: auto;
      padding: 40px;
    }
  }

  vsr-product-card .vsr-product-card__fixed-image img {
    max-width: 100%; /* Allow images to use available space */
    max-height: 648px; /* Allow natural height */
    width: auto;
    height: auto;
  }

  vsr-product-card .vsr-product-card__description {
    max-width: 416px;
  }

  vsr-icon-card {
    max-width: 648px;
    @media (max-width: 768px) {
      max-width: none;
    }
  }

  vsr-icon-card .vsr-icon-card_container {
    max-width: 648px;
    /* Remove padding - let icon card use its natural layout */
    @media (max-width: 768px) {
      max-width: none;
    }
    @media (min-width: 768px) {
      min-height: 420px;
    }
  }

  vsr-icon-card .vsr-icon-card_image img {
    /* Let icon card use its original image sizing */
    max-width: 100px;
    @media (min-width: 768px) {
      max-width: 200px;
    }
  }

  .vsr-card__image-container {
    width: 100%;
    max-width: 648px;
    background: transparent;
    @media (max-width: 768px) {
      width: auto;
    }
  }

  .vsr-card__image {
    max-width: 640px;
    @media (max-width: 768px) {
      max-width: none;
    }
  }

  .vsr-card:not(.no-hover-16-9) .vsr-card__image {
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .vsr-card__description {
    max-width: 416px;
  }
}

.vs-content-card__2up-second-card {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 56px;
  }

  @media (max-width: 767px) {
    width: 100%;
    max-width: 300px;
    padding: 0;
    justify-content: flex-start;
  }
  @media (max-width: 568px) {
    max-width: 225px;
  }

  .vsr-card {
    max-width: 366px;
    border: none;
    background: transparent;
    @media (max-width: 768px) {
      max-width: none;
    }
  }

  vsr-product-card {
    max-width: 366px;
    border: none;
    background: transparent;
    @media (max-width: 768px) {
      max-width: none;
    }

    .vsr-product-card {
      max-width: 366px;
      @media (max-width: 768px) {
        max-width: none;
      }
    }

    .vsr-product-card__fixed-image {
      width: 100%;
      max-width: 366px;
      height: auto;
      padding: 45px; /* Generous padding for consistent spacing */
      box-sizing: border-box;
      @media (max-width: 768px) {
        width: auto;
        padding: 30px;
      }
    }

    .vsr-product-card__fixed-image img {
      max-width: 100%; /* Allow images to use available space */
      max-height: none; /* Allow natural height */
      width: auto;
      height: auto;
    }
  }

  vsr-icon-card {
    max-width: 366px;
    border: none;
    background: transparent;
    @media (max-width: 768px) {
      max-width: none;
    }

    .vsr-icon-card_container {
      max-width: 366px;
      /* Remove padding - let icon card use its natural layout */
      @media (max-width: 768px) {
        max-width: none;
      }
    }

    .vsr-icon-card_image img {
      /* Let icon card use its original image sizing */
      max-width: 64px;
      @media (min-width: 768px) {
        max-width: 120px;
      }
    }
  }

  .vsr-card__image-container {
    width: 100%;
    max-width: 366px;
    background: transparent;
    @media (max-width: 768px) {
      width: auto;
    }
  }

  .vsr-card__image {
    max-width: 366px;
    width: 100%;
    @media (max-width: 768px) {
      max-width: none;
    }
  }

  .vsr-card:not(.no-hover-16-9) .vsr-card__image {
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }
}
